/* OUD CLOSET — bespoke interactions: header state, mega-menu,
   mobile drawer, custom cursor, scroll reveals. Vanilla, no deps. */
(function () {
  'use strict';
  var doc = document;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init() {
    var hdr = doc.querySelector('[data-oud-header]');
    var overlay = hdr && hdr.getAttribute('data-overlay') === 'true';

    /* ---------- header solid-on-scroll (overlay templates only) ---------- */
    if (hdr && overlay) {
      var solidify = function () {
        if (window.scrollY > 40) hdr.classList.add('is-solid');
        else if (!hdr.classList.contains('is-mega-open')) hdr.classList.remove('is-solid');
      };
      solidify();
      window.addEventListener('scroll', solidify, { passive: true });
    }

    /* ---------- mega-menu (hover intent + focus + keyboard) ---------- */
    var scrim = doc.querySelector('[data-oud-scrim]');
    var items = Array.prototype.slice.call(doc.querySelectorAll('[data-mega-trigger]'));
    var closeTimer;

    function openMega(item) {
      clearTimeout(closeTimer);
      items.forEach(function (it) {
        var p = it.querySelector('.oud-mega');
        if (it !== item && p) { p.classList.remove('is-open'); it.classList.remove('is-active'); }
      });
      var panel = item.querySelector('.oud-mega');
      if (!panel) return;
      panel.classList.add('is-open');
      item.classList.add('is-active');
      if (hdr) { hdr.classList.add('is-solid'); hdr.classList.add('is-mega-open'); }
      if (scrim) scrim.classList.add('is-open');
    }
    function closeMega() {
      closeTimer = setTimeout(function () {
        items.forEach(function (it) {
          var p = it.querySelector('.oud-mega');
          if (p) p.classList.remove('is-open');
          it.classList.remove('is-active');
        });
        if (hdr) {
          hdr.classList.remove('is-mega-open');
          if (!(overlay && window.scrollY <= 40)) { /* keep solid if scrolled */ }
          else hdr.classList.remove('is-solid');
        }
        if (scrim) scrim.classList.remove('is-open');
      }, 120);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { if (finePointer) openMega(item); });
      item.addEventListener('mouseleave', closeMega);
      var trigger = item.querySelector('[data-mega-button]');
      if (trigger) {
        trigger.addEventListener('focus', function () { openMega(item); });
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var panel = item.querySelector('.oud-mega');
          if (panel && panel.classList.contains('is-open')) closeMega();
          else openMega(item);
        });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMega();
      });
    });
    if (scrim) scrim.addEventListener('mouseenter', closeMega);
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });

    /* ---------- mobile drawer ---------- */
    var drawer = doc.querySelector('[data-oud-drawer]');
    var drawerOverlay = doc.querySelector('[data-oud-drawer-overlay]');
    var burger = doc.querySelector('[data-oud-burger]');
    var drawerClose = doc.querySelector('[data-oud-drawer-close]');
    function openDrawer() { if (drawer) drawer.classList.add('is-open'); if (drawerOverlay) drawerOverlay.classList.add('is-open'); doc.documentElement.style.overflow = 'hidden'; }
    function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); if (drawerOverlay) drawerOverlay.classList.remove('is-open'); doc.documentElement.style.overflow = ''; }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

    /* ---------- scroll reveal ---------- */
    var reveals = Array.prototype.slice.call(doc.querySelectorAll('[data-reveal]'));
    if (reveals.length) {
      if (prefersReduced || !('IntersectionObserver' in window)) {
        reveals.forEach(function (el) { el.classList.add('is-in'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        reveals.forEach(function (el) { io.observe(el); });
      }
    }

    /* custom cursor intentionally removed — the cursor:none + lagging dot
       desynced on scroll and caused the "glitching mouse". Native cursor restored. */

    /* ---------- PDP: length -> variant, lightbox, wishlist ---------- */
    var pdp = doc.querySelector('[data-oud-pdp]');
    if (pdp) {
      var variantsData = [];
      var vNode = pdp.querySelector('[data-variants]');
      if (vNode) { try { variantsData = JSON.parse(vNode.textContent); } catch (e) {} }
      var idInput = pdp.querySelector('.oud-pdp__variant-id');
      var atc = pdp.querySelector('.oud-pdp__atc');
      var atcLabel = atc ? atc.querySelector('span') : null;
      var lengthInputs = Array.prototype.slice.call(pdp.querySelectorAll('input[data-length]'));

      function selectVariant() {
        var chosen = lengthInputs.filter(function (i) { return i.checked; })[0];
        if (!chosen) return;
        var v = variantsData.filter(function (x) { return String(x.option1) === String(chosen.value); })[0];
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (atc && atcLabel) {
          if (v.available) { atc.disabled = false; atcLabel.textContent = atc.getAttribute('data-add'); }
          else { atc.disabled = true; atcLabel.textContent = atc.getAttribute('data-soldout'); }
        }
      }
      lengthInputs.forEach(function (i) { i.addEventListener('change', selectVariant); });
      selectVariant();

      var save = pdp.querySelector('.oud-pdp__save');
      if (save) save.addEventListener('click', function () { save.classList.toggle('is-saved'); });

      var lb = doc.querySelector('[data-oud-lightbox]');
      if (lb) {
        var lbImg = lb.querySelector('img');
        var lbClose = lb.querySelector('.oud-lightbox__close');
        var closeLb = function () { lb.classList.remove('is-open'); doc.documentElement.style.overflow = ''; };
        Array.prototype.slice.call(pdp.querySelectorAll('[data-zoom]')).forEach(function (fig) {
          fig.addEventListener('click', function () {
            var src = fig.getAttribute('data-zoom');
            if (src && lbImg) { lbImg.src = src; lb.classList.add('is-open'); doc.documentElement.style.overflow = 'hidden'; }
          });
        });
        if (lbClose) lbClose.addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
      }
    }
  });
})();
